import { baseApi } from '@/utils/requestConfig'

export function getFavoriteStation() {
  return baseApi.get('/my-geo/favorites/my-oeamtc-base')
}
